import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import Instruction from "TaskDialogCommon/Instruction";
import { getData } from "Utils/Common";
import store from "store";
import { TowerEventMapSelector } from "TaskDialogCommon/TowerEventMapSelector.js";
import { StringSelect } from "TaskDialogCommon/StringSelect";

const taskname = "towerevents";

const towerdisplaymap = {
  sagetower: "Sage(C1) Tower",
  lttower: "Lake-Town Tower",
};

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    this.state = {
      taskConfig: {
        accountdetail: accountdetailrow,
        towerplayconfig: {},
        selectedtower: "sagetower",
        openwonitems: true,
      },
      towerevents: null,
    };
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = () => {
    const { accountdetailrow } = this.props;
    var dataparams = {
      accountdetail: accountdetailrow,
      datakey: "towerevents",
    };

    store.dispatch({ type: "ISLOADING", payload: true });
    getData(dataparams, ({ data: { ok, data } }) => {
      var towerevents = null;
      if (ok) {
        towerevents = data.towerevents;
      }
      this.setState({ towerevents });
      store.dispatch({ type: "ISLOADING", payload: false });
    }).catch((error) => {
      logger.log(
        "Error",
        error.message,
        error.error && error.error.message,
        error.response
      );
      store.dispatch({ type: "ISLOADING", payload: false });
      errordialog.showError(error.response.data.message);
    });
  };

  validate = () => {
    if (!this.state.taskConfig.towerplayconfig[1]) {
      alert("Please add atleast one Floor/Event to claim.");
      return false;
    }
    return true;
  };

  setValue = (event, key) => {
    logger.log("event", event, "key", key);
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  setTaskConfigChanges = (taskConfigChanges, callBack) => {
    this.setState(
      (s, p) => ({
        taskConfig: { ...s.taskConfig, ...taskConfigChanges },
      }),
      callBack
    );
  };

  render = () => {
    const {
      setValue,
      validate,
      setTaskConfigChanges,
      state: { taskConfig, towerevents },
      props: { AccountDetailData },
    } = this;

    if (!towerevents) {
      return null;
    }

    return (
      <TaskDialog heading={"Play Tower Events/Floors"}>
        <Instruction>
          *INSTRUCTIONS: <br />
          The sequence in which events are selected are the sequence in which
          they will be cashed. So select floor 1 event first and then floor 2
          event and make sure that all floors are in sequence. <br />
          "Open Claimed Items" option will open prizes received from events.
          This is needed in towers because only when you open floor 1 prize you
          will get next floor keys. So select it accordingly.
        </Instruction>

        <StringSelect
          label={"Select Tower to play"}
          param={"selectedtower"}
          setTaskConfigChanges={(taskConfigChanges) => {
            setTaskConfigChanges(taskConfigChanges);
            setTaskConfigChanges({ towerplayconfig: {} });
          }}
          taskConfig={taskConfig}
          optionObject={towerdisplaymap}
          labelParser={(k, v) => v}
          valueParser={(k, v) => k}
        />

        <TaskCheckBox
          label={"Open Claimed Items"}
          param={"openwonitems"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TowerEventMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Select Floors/Event sequence to play"}
          param={"towerplayconfig"}
          selectedTowerData={towerevents[taskConfig.selectedtower]}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run Tower"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
